import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Guest, HotelVideos } from '../../assests/ExportImageIcon'
import MainTab from '../../componants/mainTab/MainTab'
import DatePicker from '../../componants/datePicker/DatePicker'
import PopularDestination from '../popularDestination/PopularDestination'
import SpecialOffer from '../specialOffer/SpecialOffer'
import InfluencerReels from '../influencerReels/InfluencerReels'
import GetApp from '../getApp/GetApp'
import OurLatestBlog from '../ourLatestblog/OurLatestBlog'
import { showToast } from '../../componants/toast/toastService'

const todayIso = () => new Date().toISOString().slice(0, 10)

const VenueMain = () => {
  const navigate = useNavigate()
  const [location, setLocation] = useState('')
  const [eventDate, setEventDate] = useState('')
  const [guests, setGuests] = useState(50)

  const handleSearchVenues = () => {
    if (!location.trim()) {
      showToast('Please enter a location', 'error')
      return
    }
    if (!eventDate) {
      showToast('Please select an event date', 'error')
      return
    }

    navigate('/venue-list', { state: { location, eventDate, guests } })
  }

  return (
    <>
      <section className='banner'>
        <div className='videoPart'>
          <video className='promoBanner' autoPlay loop muted playsinline="" data-object-fit="cover" preload="metadata">
            <source src={HotelVideos} type="video/mp4" />
          </video>
        </div>
        <div className='bannerContent'>
          <div className='container'>
            <div className='row g-4'>
              <div className='col-md-12'>
                <h1>Book Your Venue With Just One Click</h1>
                <MainTab />
              </div>
              <div className='col-md-12'>
                <div className='bookingAreaanner'>
                  <div className='hotelSearchArea mt-0'>
                    <div className='hotelSearchUp'>
                      <div className='hotelSearchField cmnBdr'>
                        <div className='hotelSearchInput'>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 22s7-7.05 7-12a7 7 0 1 0-14 0c0 4.95 7 12 7 12Z" stroke="#6B7280" strokeWidth="1.5" />
                            <circle cx="12" cy="10" r="2.5" stroke="#6B7280" strokeWidth="1.5" />
                          </svg>
                          <div>
                            <input
                              type="text"
                              placeholder="Where is your event?"
                              value={location}
                              onChange={(e) => setLocation(e.target.value)}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className='hotelSearchField cmnBdr'>
                        <div className='hotelSearchInput'>
                          <div>
                            <DatePicker
                              className='searchBarDateField'
                              min={todayIso()}
                              value={eventDate}
                              onChange={setEventDate}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='hotelSearchField'>
                        <div className='hotelSearchInput'>
                          <img src={Guest} alt="Guests" />
                          <div>
                            <input
                              type="number"
                              min={1}
                              placeholder="Guests"
                              value={guests}
                              onChange={(e) => setGuests(Math.max(1, Number(e.target.value) || 1))}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type='button'
                        className='commonBtn'
                        onClick={handleSearchVenues}
                      >
                        Search Venues
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PopularDestination />

      <SpecialOffer />

      <InfluencerReels />

      <GetApp />

      <OurLatestBlog />
    </>
  )
}

export default VenueMain
